
<main class="container">

  <div class="product-layout">

    <!-- ====================================================
         DESKTOP FILTER SIDEBAR
         ==================================================== -->

    <aside class="filters-sidebar">

      <app-product-filters
        [categories]="categories()"
        [subCategories]="subCategories()"
        [brands]="brands()"

        [selectedCategoryId]="selectedCategoryId()"
        [selectedSubCategoryId]="selectedSubCategoryId()"
        [selectedBrandId]="selectedBrandId()"

        [showOffers]="showOffers()"

        (filterApplied)="onFilterApplied($event)"
        (clearFiltersEvent)="clearFilters()">
      </app-product-filters>

    </aside>


    <!-- ====================================================
         PRODUCTS AREA
         ==================================================== -->

    <section class="products-area">


      <!-- ==================================================
           MOBILE FILTER BUTTON
           ================================================== -->

      <button
        type="button"
        class="mobile-filter-button"
        (click)="openMobileFilters()">

        <mat-icon>
          filter_list
        </mat-icon>

        <span>
          {{ 'FILTER.FILTERS' | translate }}
        </span>

        <span
          class="filter-count"
          *ngIf="activeFilterCount() > 0">

          {{ activeFilterCount() }}

        </span>

      </button>


      <!-- ==================================================
           ACTIVE FILTERS
           ================================================== -->

      <section
        class="active-filters"

        *ngIf="
          hasSearch() ||
          selectedCategoryId() !== null ||
          selectedSubCategoryId() !== null ||
          selectedBrandId() !== null ||
          showOffers()
        ">

        <div class="active-filter-title">

          <mat-icon>
            filter_alt
          </mat-icon>

          <span>
            {{ 'FILTER.Active_Filters' | translate }}
          </span>

        </div>


        <div class="active-filter-list">


          <!-- ==================================================
               SEARCH
               ================================================== -->

          <div
            class="filter-chip search-chip"
            *ngIf="hasSearch()">

            <mat-icon>
              search
            </mat-icon>

            <strong>
              {{ searchName() }}
            </strong>

            <button
              type="button"
              class="remove-filter"
              (click)="clearSearch()"
              [attr.aria-label]="'COMMON.CLEAR' | translate">

              <mat-icon>
                close
              </mat-icon>

            </button>

          </div>


          <!-- ==================================================
               CATEGORY
               ================================================== -->

          <div
            class="filter-chip"
            *ngIf="selectedCategoryId() !== null">

            <span>
              {{ 'FILTER.CATEGORY' | translate }}
            </span>

            <strong>
              {{ selectedCategoryName }}
            </strong>

            <button
              type="button"
              class="remove-filter"
              (click)="clearCategory()">

              <mat-icon>
                close
              </mat-icon>

            </button>

          </div>


          <!-- ==================================================
               SUBCATEGORY
               ================================================== -->

          <div
            class="filter-chip"
            *ngIf="selectedSubCategoryId() !== null">

            <span>
              {{ 'FILTER.SUBCATEGORY' | translate }}
            </span>

            <strong>
              {{ selectedSubCategoryName }}
            </strong>

            <button
              type="button"
              class="remove-filter"
              (click)="clearSubCategory()">

              <mat-icon>
                close
              </mat-icon>

            </button>

          </div>


          <!-- ==================================================
               BRAND
               ================================================== -->

          <div
            class="filter-chip"
            *ngIf="selectedBrandId() !== null">

            <span>
              {{ 'FILTER.BRAND' | translate }}
            </span>

            <strong>
              {{ selectedBrandName }}
            </strong>

            <button
              type="button"
              class="remove-filter"
              (click)="clearBrand()">

              <mat-icon>
                close
              </mat-icon>

            </button>

          </div>


          <!-- ==================================================
               OFFERS
               ================================================== -->

          <div
            class="filter-chip offer-chip"
            *ngIf="showOffers()">

            <mat-icon>
              local_offer
            </mat-icon>

            <strong>
              {{ 'FILTER.OFFERS' | translate }}
            </strong>

            <button
              type="button"
              class="remove-filter"
              (click)="clearOffers()">

              <mat-icon>
                close
              </mat-icon>

            </button>

          </div>


          <!-- ==================================================
               CLEAR ALL
               ================================================== -->

          <button
            type="button"
            class="clear-active-filters"
            (click)="clearFilters()">

            {{ 'COMMON.CLEAR' | translate }}

          </button>

        </div>

      </section>


      <!-- ==================================================
           PRODUCTS
           ================================================== -->

      <section
        class="product-grid"

        *ngIf="
          !isLoading() &&
          filteredProducts().length > 0
        ">

        <app-product-card
          *ngFor="
            let product of filteredProducts()
          "

          [product]="product"

          [imageApi]="api"

          [showAlreadyInCartMessage]="
            alreadyInCartProductId() === product.id
          "
[showAddedCheck]="
  addedToCartProductId() === product.id
"
          (productClicked)="
            openProductDetails($event)
          "

          (addToCartClicked)="
            addToCart($event)
          ">
        </app-product-card>

      </section>


      <!-- ==================================================
           LOADING
           ================================================== -->

      <div
        *ngIf="isLoading()"
        class="loading-spinner">

        <span class="loading-icon">
          ✦
        </span>

        <span>
          {{ 'COMMON.LOADING' | translate }}
        </span>

      </div>


      <!-- ==================================================
           LOADING MORE
           ================================================== -->

      <div
        *ngIf="isLoadingMore()"
        class="loading-more">

        <span class="loading-icon small">
          ✦
        </span>

        <span>
          {{ 'COMMON.LOADING' | translate }}
        </span>

      </div>


      <!-- ==================================================
           NO PRODUCTS
           ================================================== -->

      <section
        *ngIf="
          !isLoading() &&
          filteredProducts().length === 0
        "
        class="no-products">

        <span class="no-products-icon">
          ✦
        </span>

        <h3>
          {{ 'PRODUCT.No_Products_Found' | translate }}
        </h3>

        <p>
          {{ 'PRODUCT.FILTER_DISMATCH' | translate }}
        </p>

        <button
          type="button"
          class="show-all-button"
          (click)="clearFilters()">

          <mat-icon>
            refresh
          </mat-icon>

          <span>
            {{ 'PRODUCT.Show_All_Products' | translate }}
          </span>

        </button>

      </section>

    </section>

  </div>

</main>
